<template>
    <div class="focus">
        <slot name="content" />
    </div>
</template>

<script>
export default {
    name: 'GrayContentWrapper',
    inject: ['$validator']
};
</script>
<style lang="scss" scoped>
@import 'src/styles/all';

.focus {
    background-color: $light-gray;
    padding: 20px;
    border-radius: $global-radius;
}
</style>
